export default "__VITE_ASSET__yitPGU74__"